import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Card } from '@material-tailwind/react';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ArcElement, Tooltip, Legend);

const NumberFormatter = (value) => {
    const options = {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    };
    return value ? Number(value).toLocaleString('en', options) : ''
};

export const options = {
    /*   responsive: true, */
    maintainAspectRatio: false,
    tooltips: {
        enabled: true,
    },
    /* layout: {
       padding:{}
      }, */
    plugins: {
        legend: {
            display: true,
            position: "bottom"
        },
        title: {
            display: true,
            text: ' (افغانی) انواع عوايد',
            margin: {
                bottom: 20
            }
        },
        datalabels: {
            display: 'auto',
            color: 'black',
            font: {
                weight: 'bold'
            },
            formatter: (value, ctx) => {

                if (value) {
                    /*   const total = ctx.chart.getDatasetMeta(0).total;
                      let percentage = (value * 100 / total).toFixed(2) + "%";
                      return percentage + '(' + value + ')'; */
                    return NumberFormatter(value) + ' ؋'
                }

            },
        }
    },
}

export const data = (v) => {
    return {
        labels: ['موارد ديگر ', 'کارت عضويت', 'کرايه', 'صادرات', 'صفايي ملکيت', 'واردات'],
        datasets: [
            {
                label: 'افغانی',
                data: [v?.others, v?.membershipCards, v?.rentals, v?.exports, v?.cleanliness, v?.imports],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(153, 152, 25, 0.2)',
                    'rgba(10,231,183, 0.2)'


                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(153, 152, 25, 1)',
                    'rgba(5,150,105, 1)'
                ],
                borderWidth: 1,
            },
        ],
    }
};

export function PeiCahrt({ v }) {

    return <Card className={`bg-white shadow-lg shadow-gray-200 rounded-2xl p-4  ${v.className}`}>
        <Pie data={data(v.data)} options={options} plugins={[ChartDataLabels]} />
    </Card>

}
